import axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { getWithRedirect } from 'utils/axios'

import {
  CreatedTrustLink,
  TrustLink,
  TrustLinkBody
} from 'types/GlobalTrustLink'

const BASE_URL
  = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/internal/trust-links`

export async function getTrustLinks() {
  return getWithRedirect<TrustLink[]>(URL, parseAuthenticationHeader())
}

export async function createTrustLink(body: TrustLinkBody) {
  return axios.post<{ data: CreatedTrustLink }>(
    URL,
    { data: body },
    parseAuthenticationHeader()
  )
}

export async function revokeTrustLink(id: string) {
  return axios.post<{ data: { id: string; status: string } }>(
    `${URL}/${id}/revoke`,
    {},
    parseAuthenticationHeader()
  )
}
